import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpEvent,
  HttpEventType,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, Observable, Subject, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  isCategoryAdded: boolean = false;
  isEditCategory: boolean = false;
  contentPageType: any = 'FA';
  contentPageDesc: any = '';
  selectedCatalog: string = '';
  activeSelection = {
    selectedSeqId: '',
  };
  selectedContent: string = '';
  menuCollapse: boolean = false;
  contentPageTypeTitle: any = {
    CO: 'Coordinator',
    C1: 'Custom Content',
    FA: 'Frequently Asked Questions',
    N: 'News',
    ON: 'Online Chat',
    O: 'Overview',
    S: 'Support',
    W: 'Welcome',
    BI:'Power BI Reports',
    NL: 'Navigation Link'
  };
  mainMenuList: any;
  private actionSource = new Subject<{ type: string }>();
  action$ = this.actionSource.asObservable();

  constructor(
    private httpClient: HttpClient,
    private notification: NzNotificationService,
  ) {}

  triggerAction(type: string) {
    this.actionSource.next({ type });
  }

  getCatalogData(): Observable<any> {
    let apiUrl = '/admin/customer-catalog/search';
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getOldCatalogList(): Observable<any> {
    let apiUrl = '/admin/customer-catalog/old-catalogs';
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getCatalogTreeById(id: any): Observable<any> {
    let apiUrl = '/admin/customer-catalog/category?catalogId=' + id;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  addCatalogData(data: any): Observable<any> {
    let apiUrl = '/admin/customer-catalog/';
    return this.httpClient.post(apiUrl, data).pipe(tap((result: any) => {}));
  }

  getCategoryDetailById(id: any): Observable<any> {
    let apiUrl = '/admin/customer-catalog/category-details?seqNoId=' + id;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getCategoryMultiLot(
    catalogId: string,
    seqNo: string,
    styleId: string,
    version: string,
  ): Observable<any> {
    let apiUrl =
      '/admin/customer-catalog/multilot-update?catalogId=' +
      catalogId +
      '&seqNo=' +
      seqNo +
      '&styleId=' +
      styleId +
      '&version=' +
      version;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getCategoryPreviewDetail(id: any): Observable<any> {
    let apiUrl = '/admin/customer-catalog/category-preview?seqNoId=' + id;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getParentCategories(catalogId: string, seqNo: string): Observable<any> {
    let apiUrl =
      '/admin/customer-catalog/category/parents?catalogId=' +
      catalogId +
      '&seqNoId=' +
      seqNo;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getLots(seqNo: string, styleId: string): Observable<any> {
    let apiUrl =
      '/admin/customer-catalog/category/available-lots?seqNo=' +
      seqNo +
      '&styleId=' +
      styleId;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getOtherStyleLots(seqNo: string, lotId: string): Observable<any> {
    let apiUrl =
      '/admin/customer-catalog/category/search-lots?seqNo=' +
      seqNo +
      '&lotId=' +
      lotId;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  addAssociateLots(styleID: any, data: any): Observable<any> {
    let apiUrl = '/admin/customer-catalog/category/lot?styleId=' + styleID;
    return this.httpClient.post(apiUrl, data).pipe(tap((result: any) => {}));
  }

  deleteAssociateLots(data: any): Observable<any> {
    let apiUrl = '/admin/customer-catalog/category/lot';
    return this.httpClient
      .delete(apiUrl, { body: data })
      .pipe(tap((result: any) => {}));
  }

  addCategory(data: any): Observable<any> {
    let apiUrl = '/admin/customer-catalog/category';
    return this.httpClient.post(apiUrl, data).pipe(tap((result: any) => {}));
  }

  updateCategory(data: any, multiLotUpdateFlag: boolean): Observable<any> {
    let apiUrl =
      '/admin/customer-catalog/category?multiLotUpdateFlag=' +
      multiLotUpdateFlag;
    return this.httpClient.put(apiUrl, data).pipe(tap((result: any) => {}));
  }

  deleteCategory(seqNo: string): Observable<any> {
    let apiUrl = '/admin/customer-catalog/category?seqNo=' + seqNo;
    return this.httpClient.delete(apiUrl).pipe(tap((result: any) => {}));
  }

  duplicateCategory(catalogId: string, seqNo: string): Observable<any> {
    let apiUrl =
      '/admin/customer-catalog/copyCategoryTree?catalogId=' +
      catalogId +
      '&seqNo=' +
      seqNo;
    return this.httpClient.post(apiUrl, {}).pipe(tap((result: any) => {}));
  }

  updateCategorySequence(data: any): Observable<any> {
    let apiUrl = '/admin/customer-catalog/sequence';
    return this.httpClient.patch(apiUrl, data).pipe(tap((result: any) => {}));
  }

  getContentPageType(): Observable<any> {
    let apiUrl = '/admin/content/pagetypes';

    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getContentListByPageType(pageType: string): Observable<any> {
    let apiUrl = '/admin/content/descriptions?pageType=' + pageType;

    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  addContent(data: any) {
    return this.httpClient
      .post('/admin/content/', data)
      .pipe(tap((result: any) => {}));
  }

  updateContent(seqNo: any, data: any) {
    return this.httpClient
      .put('/admin/content/?seqNo=' + seqNo, data)
      .pipe(tap((result: any) => {}));
  }

  getContentById(seqId: string): Observable<any> {
    let apiUrl = '/admin/content/details?seqNo=' + seqId;

    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  deleteContentById(pageType: string, seqId: string): Observable<any> {
    let apiUrl =
      '/admin/content/details?pageType=' + pageType + '&seqNo=' + seqId;

    return this.httpClient.delete(apiUrl).pipe(tap((result: any) => {}));
  }

  getEdpArNoList(edpNo: string, seqId: string): Observable<any> {
    let apiUrl = '/admin/content/edpar?edpNo=' + edpNo + '&seqNo=' + seqId;

    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getAssociatedEdpArList(seqId: string): Observable<any> {
    let apiUrl = '/admin/content/edpar-associate?seqNo=' + seqId;

    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  updateAssociatedEdpArList(data: any): Observable<any> {
    let apiUrl = '/admin/content/edpar-associate';

    return this.httpClient.put(apiUrl, data).pipe(tap((result: any) => {}));
  }

  getProgramList(): Observable<any> {
    let apiUrl = '/admin/content/prg';

    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getWorkProgramList(seqId: string, prgmCode: string): Observable<any> {
    const params = new HttpParams()
      .set('seqNo', seqId)
      .set('programCode', prgmCode);
    let apiUrl = '/admin/content/prg/workgroup';

    return this.httpClient
      .get(apiUrl, { params })
      .pipe(tap((result: any) => {}));
  }

  getPrgrmAssociation(seqId: string): Observable<any> {
    let apiUrl = '/admin/content/prg/associate?seqNo=' + seqId;

    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  updateAssociation(seqId: string, data: any): Observable<any> {
    let apiUrl = '/admin/content/edpar-associate?seqNo=' + seqId;

    return this.httpClient.put(apiUrl, data).pipe(tap((result: any) => {}));
  }

  updatePrgrmAssociation(seqId: string, data: any): Observable<any> {
    let apiUrl = '/admin/content/prg/associate';
    return this.httpClient.put(apiUrl, data).pipe(tap((result: any) => {}));
  }

  getMasterCatalogList(): Observable<any> {
    let apiUrl = 'admin/master-catalog/search';
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getMasterCatalogAttributes(): Observable<any> {
    let apiUrl = '/admin/master-catalog/attrmaster';
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  addMasterCatalogProduct(data: any): Observable<any> {
    return this.httpClient
      .post('admin/master-catalog/', data)
      .pipe(tap((result: any) => {}));
  }

  editMasterCatalogProduct(data: any): Observable<any> {
    return this.httpClient
      .put('admin/master-catalog/', data)
      .pipe(tap((result: any) => {}));
  }

  getStyleList(): Observable<any> {
    let apiUrl = '/admin/master-catalog/styleid?styleId=';
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getBrandList(): Observable<any> {
    let apiUrl = '/admin/master-catalog/search/brand';
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getGarmentList(brand: string): Observable<any> {
    let apiUrl = '/admin/master-catalog/search/garment?brand=' + brand;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getSubGarmentList(brand: string, garment: string): Observable<any> {
    let apiUrl =
      '/admin/master-catalog/search/subgarment?brand=' +
      brand +
      '&garment=' +
      garment;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getStyleIdList(): Observable<any> {
    let apiUrl = '/admin/master-catalog/master-catalog-style-ids';
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getProductList(
    brand: string,
    garment: string,
    subgarment: string,
    searchStyleText: string,
    searchVersionText: string,
    pageNumber: number,
    limit: number,
    includeDeleted: boolean,
    lotId: string,
  ): Observable<any> {
    let apiUrl =
      '/admin/master-catalog/filter?&page=' +
      pageNumber +
      '&limit=' +
      limit +
      '&includeDeleted=' +
      includeDeleted;

    let params = new HttpParams();

    if (searchStyleText != '' && searchStyleText !== null) {
      params = params.set('styleId', searchStyleText);
    }
    if (searchVersionText != '' && searchVersionText !== null) {
      params = params.set('version', searchVersionText);
    }

    if (brand != '' && brand !== null) {
      params = params.set('brand', brand);
    }
    if (garment != '' && garment !== null) {
      params = params.set('garment', garment);
    }
    if (subgarment != '' && subgarment !== null) {
      params = params.set('subgarment', subgarment);
    }
    if (includeDeleted) {
      params = params.set('includeDeleted', includeDeleted);
    }
    if (lotId) {
      params = params.set('lotId', lotId);
    }
    return this.httpClient
      .get(apiUrl, { params })
      .pipe(tap((result: any) => {}));
  }

  getProductDetails(productId: string, version: string): Observable<any> {
    let apiUrl =
      '/admin/master-catalog/product?styleId=' +
      productId +
      '&version=' +
      version;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  deleteProductDetails(productId: string, version: string): Observable<any> {
    let apiUrl =
      '/admin/master-catalog/?version=' + version + '&styleId=' + productId;
    return this.httpClient.delete(apiUrl).pipe(tap((result: any) => {}));
  }

  unDeleteProductDetails(productId: string, version: string): Observable<any> {
    let apiUrl =
      '/admin/master-catalog/undelete?version=' +
      version +
      '&styleId=' +
      productId;
    return this.httpClient.put(apiUrl, {}).pipe(tap((result: any) => {}));
  }

  mergeProductDetails(data: any): Observable<any> {
    let apiUrl = '/admin/master-catalog/merge/style';
    return this.httpClient.put(apiUrl, data).pipe(tap((result: any) => {}));
  }

  moveProductDetails(data: any): Observable<any> {
    let apiUrl = '/admin/master-catalog/move/style';
    return this.httpClient.put(apiUrl, data).pipe(tap((result: any) => {}));
  }

  associatedCatalogDetails(
    productId: string,
    version: string,
  ): Observable<any> {
    let apiUrl =
      'admin/master-catalog/associatedcatalogs?version=' +
      version +
      '&styleId=' +
      productId;
    return this.httpClient.get(apiUrl, {}).pipe(tap((result: any) => {}));
  }

  getProgramCode(): Observable<any> {
    let apiUrl = 'admin/misc/program-code';
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getLocationCode(programCode: string): Observable<any> {
    let apiUrl = 'admin/misc/location-code?programCode=' + programCode;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getLocationJobCode(locationCode: string): Observable<any> {
    let apiUrl = 'admin/misc/loc-jc?locationCode=' + locationCode;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getJobCode(programCode: string, locationCode: string): Observable<any> {
    let apiUrl =
      'admin/misc/job-code?programCode=' +
      programCode +
      '&locationCode=' +
      locationCode;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  updateJobLocCode(data: any): Observable<any> {
    let apiUrl = 'admin/misc/loc-jc';
    return this.httpClient.put(apiUrl, data).pipe(tap((result: any) => {}));
  }

  getCatalogAssociatedEdpArList(catelogId: string): Observable<any> {
    let apiUrl =
      '/admin/customer-catalog/associate-aredp?catalogId=' + catelogId;

    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getCatelogEdpArNoList(catelogId: string, edpNo: string): Observable<any> {
    let apiUrl =
      '/admin/customer-catalog/edp-ar?catalogId=' +
      catelogId +
      '&edpNo=' +
      edpNo;

    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  updateCatalogEdpArList(data: any): Observable<any> {
    let apiUrl = '/admin/customer-catalog/associate-aredp';

    return this.httpClient.post(apiUrl, data).pipe(tap((result: any) => {}));
  }

  getDimList(dim: string): Observable<any> {
    let apiUrl = '/admin/size/' + dim;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getCatalogUsers(catalogId: string): Observable<any> {
    let apiUrl = '/admin/customer-catalog/user?catalogId=' + catalogId;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  updateCatalogUsers(catalogId: string, data: any): Observable<any> {
    let apiUrl = '/admin/customer-catalog/user?catalogId=' + catalogId;
    return this.httpClient.put(apiUrl, data).pipe(tap((result: any) => {}));
  }

  getFilterCriteria(catalogId: String): Observable<any> {
    let apiUrl =
      '/admin/customer-catalog/product-filter?catalogId=' + catalogId;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  updateFilterCriteria(catalogId: String, data: any): Observable<any> {
    let apiUrl =
      '/admin/customer-catalog/product-filter?catalogId=' + catalogId;
    return this.httpClient.put(apiUrl, data).pipe(tap((result: any) => {}));
  }

  getAssociatedLot(catalogId: String): Observable<any> {
    let apiUrl =
      '/admin/customer-catalog/lot-filter?catalogId=' + catalogId + '&lotId=';
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getAssociatedLotSizes(catalogId: String, lotId: string): Observable<any> {
    let apiUrl =
      '/admin/customer-catalog/lot-size?catalogId=' +
      catalogId +
      '&lotId=' +
      lotId;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }
  getLotFilterSizes(lotId: string, catalogId: any): Observable<any> {
    let apiUrl =
      'admin/customer-catalog/lot-size/available?lotId=' +
      lotId +
      '&catalogId=' +
      catalogId;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  updateLotSizes(
    catalogId: String,
    lotId: string,
    action: string,
    body: any,
  ): Observable<any> {
    let apiUrl =
      '/admin/customer-catalog/lot-size?catalogId=' +
      catalogId +
      '&lotId=' +
      lotId +
      '&updateType=' +
      action;
    return this.httpClient.post(apiUrl, body).pipe(tap((result: any) => {}));
  }

  getCatalogDetail(catalogId: String): Observable<any> {
    let apiUrl = '/admin/customer-catalog/?catalogId=' + catalogId;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  updateCatalogDetail(data: any): Observable<any> {
    let apiUrl = '/admin/customer-catalog/';
    return this.httpClient.put(apiUrl, data).pipe(tap((result: any) => {}));
  }

  getGarmentTypes(): Observable<any> {
    let apiUrl = '/admin/size/lot/garment-type';
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  postDimData(data: any, dim: string): Observable<any> {
    let apiUrl = '/admin/size/' + dim;
    return this.httpClient.put(apiUrl, data).pipe(tap((result: any) => {}));
  }

  postSequenceDim(data: any, dim: string): Observable<any> {
    let apiUrl = '/admin/size/' + dim + '/sequence/new';
    return this.httpClient.patch(apiUrl, data).pipe(tap((result: any) => {}));
  }

  getUsersByIdEdpArNo(searchVal: string, criteria: string): Observable<any> {
    let apiUrl = '';
    if (criteria === 'UserId') {
      apiUrl = 'admin/site/web-account/npg/users?userId=' + searchVal;
    } else if (criteria === 'AR' || criteria === 'EDP') {
      apiUrl = 'admin/site/web-account/npg/users/aredp?edpNo=' + searchVal;
    }
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  deleteUserById(searchVal: string): Observable<any> {
    let apiUrl = 'admin/site/web-account/npg/users?userid=' + searchVal;

    return this.httpClient.delete(apiUrl).pipe(tap((result: any) => {}));
  }
  addUpdateUser(data: any, action: string): Observable<any> {
    let apiUrl = 'admin/site/web-account/npg/users';
    if (action === 'Edit') {
      return this.httpClient.put(apiUrl, data).pipe(tap((result: any) => {}));
    } else if (action === 'Add') {
      return this.httpClient.post(apiUrl, data).pipe(tap((result: any) => {}));
    }
    console.warn(`Unsupported action: ${action}`);
    return EMPTY;
  }

  getFedexOrgCodeList(): Observable<any> {
    let apiUrl = '/admin/site/fedex-org';
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  updateFedexOrgCodeList(data: any): Observable<any> {
    let apiUrl = '/admin/site/fedex-org';
    return this.httpClient.put(apiUrl, data).pipe(tap((result: any) => {}));
  }

  getAssociateCustomerList(): Observable<any> {
    let apiUrl = '/admin/site/customers/associate';
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getAssociateCustomerById(custId: string): Observable<any> {
    let apiUrl = '/admin/site/customer?custId=' + custId;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getAssociateCustomerListValues(): Observable<any> {
    let apiUrl = '/admin/site/customer/lp-style-brand';
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  updateAssociateCustomerList(data: any): Observable<any> {
    let apiUrl = '/admin/site/customers/associate';
    return this.httpClient.put(apiUrl, data).pipe(tap((result: any) => {}));
  }

  deactivateCatalog(catalogId: any, activeFlag: any): Observable<any> {
    let apiUrl =
      '/admin/customer-catalog/activate-deactivate?catalogId=' +
      catalogId +
      '&activeFlag=' +
      activeFlag;
    return this.httpClient.put(apiUrl, {}).pipe(tap((result: any) => {}));
  }

  deleteCatalog(catalogId: any): Observable<any> {
    let apiUrl = '/admin/customer-catalog/delete?catalogId=' + catalogId;
    return this.httpClient.delete(apiUrl, {}).pipe(tap((result: any) => {}));
  }

  publishCatalog(catalogId: any, publishFlag: any): Observable<any> {
    let apiUrl =
      '/admin/customer-catalog/publish?catalogId=' +
      catalogId +
      '&publish=' +
      publishFlag;
    return this.httpClient.put(apiUrl, {}).pipe(tap((result: any) => {}));
  }

  migrateAsyncCatalog(catalogId: any): Observable<any> {
    let apiUrl = '/admin/customer-catalog/migrate-async?catalogId=' + catalogId;
    return this.httpClient.post(apiUrl, {}).pipe(tap((result: any) => {}));
  }

  catalogMigrateStatus(catalogId: any): Observable<any> {
    let apiUrl =
      '/admin/customer-catalog/migrate-async/status?catalogId=' + catalogId;
    return this.httpClient.get(apiUrl, {}).pipe(tap((result: any) => {}));
  }

  importCatalog(file: any) {
    const formData = new FormData();
    formData.append('file', file);
    let apiUrl = 'admin/customer-catalog/import';
    return this.httpClient
      .post(apiUrl, formData, {})
      .pipe(tap((result: any) => {}));
  }

  private handleError(error: HttpErrorResponse) {
    console.error('Upload error:', error);
    return throwError(() => new Error('File upload failed.'));
  }

  exportCatalog(catalogId: any): Observable<any> {
    let apiUrl = '/admin/customer-catalog/export?catalogId=' + catalogId;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getPriceDisplayList(edpNo: string): Observable<any> {
    let apiUrl = '/admin/price/?edpNo=' + edpNo;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }
  getLotList(edpNo: string): Observable<any> {
    let apiUrl = '/admin/price/lots?lotId=' + edpNo;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getLotListBySearch(lotNo: string): Observable<any> {
    let apiUrl = '/admin/master-catalog/all-lots?lotId=' + lotNo;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getStyleListById(styleId: string): Observable<any> {
    let apiUrl = 'admin/master-catalog/style-id-versions?styleId=' + styleId;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }

  getEdpArNoLists(edpNo: string): Observable<any> {
    let apiUrl = '/admin/price/edp-ar?edpNo=' + edpNo;
    return this.httpClient.get(apiUrl).pipe(tap((result: any) => {}));
  }
  updatePriceDisplayList(data: any): Observable<any> {
    let apiUrl = '/admin/price/';
    return this.httpClient.post(apiUrl, data).pipe(tap((result: any) => {}));
  }

  login(username: string, password: string): Observable<any> {
    const headers = new HttpHeaders({
      username: username,
      password: password,
    });
    let apiUrl = '/admin/auth/';
    return this.httpClient
      .get(apiUrl, { headers })
      .pipe(tap((result: any) => {}));
  }

  logoutAPI(): Observable<any> {
    let apiUrl = '/admin/auth/logout';
    return this.httpClient.post(apiUrl, {}).pipe(tap((result: any) => {}));
  }

  refreshToken(): Observable<any> {
    let apiUrl = '/admin/auth/refresh-token';
    return this.httpClient
      .post(apiUrl, {}, { withCredentials: true })
      .pipe(tap((response) => {}));
  }

  createNotification(type: string, content: string, options: any = {}): any {
    return this.notification.create(type, '', content, options);
  }

  validateMenuRoute(routeUrl: string) {
    if (routeUrl) {
      this.mainMenuList.menuList.map((node: any) => {
        if (node.routes.includes(routeUrl.replace('/', '').split('/')[0])) {
          node.open = true;
        } else {
          node.open = false;
        }
      });
    }
  }
}
